<template>
  <div class="gtr-load-micro-error">
    <pb-empty :description="message">
      <pb-button type="danger" @click="$emit('reload')">
        {{ $t('FoodB_statistics_Refresh_qDDP') }}
      </pb-button>
    </pb-empty>
  </div>
</template>

<script>
export default {
  name: 'LoadAppError',
  emits: ['reload'],
  computed: {
    message() {
      return this.$t('FoodC_remind_Unable_to_Wjlz');
    },
  },
};
</script>

<style lang="scss" scoped>
.gtr-load-micro-error {
  text-align: center;
}
</style>
